// Auto generated file, do not manually modify!
// com.hotpads.customermanagement.client.listingspotlight.enums.PlacementSource

export enum PlacementSource {
  AUTO = 'AUTO',
  EXCLUDED = 'EXCLUDED',
  INCLUDED = 'INCLUDED',
  PINNED = 'PINNED',
}

export const PlacementSource_values = [
  PlacementSource.AUTO,
  PlacementSource.EXCLUDED,
  PlacementSource.INCLUDED,
  PlacementSource.PINNED,
] as const;
